// import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
// export default {
//   install () {
//     const connection = new HubConnectionBuilder()
//       .withUrl('https://localhost:44343/available')
//       .configureLogging(LogLevel.Information)
//       .build()

//     connection.start()
//   }
// }

import { HubConnectionBuilder, LogLevel } from "@aspnet/signalr";
import JwtService from "@/core/services/jwt.service";
import store from "./core/services/store";
import { LOGOUT } from "@/core/services/store/auth.module";
import ApiService from "./core/services/api.service";

export default {
  install(Vue) {
    const availabilityHub = new Vue();
    Vue.prototype.$availabilityHub = availabilityHub;

    let connection = null;
    let startedPromise = null;
    let manuallyClosed = false;

    Vue.prototype.startSignalR = () => {
      if (connection != null) {
        return;
      }

      connection = new HubConnectionBuilder()
        .withUrl(
          `${ApiService.serverURL}/hubs/users`,
          {
            accessTokenFactory: () => `${JwtService.getToken()}`,
          }
        )
        .configureLogging(LogLevel.None)
        .build();

      // Forward hub events through the event, so we can listen for them in the Vue components
      connection.on("RequestNotify", (notif) => {
        availabilityHub.$emit("request-notify", notif);
      });

      connection.on("MessageNotify", (notif) => {
        availabilityHub.$emit("message-notify", notif);
      });
      //   connection.on('QuestionScoreChange', (questionId, score) => {
      //     questionHub.$emit('score-changed', { questionId, score })
      //   })
      //   connection.on('AnswerCountChange', (questionId, answerCount) => {
      //     questionHub.$emit('answer-count-changed', { questionId, answerCount })
      //   })
      //   connection.on('AnswerAdded', answer => {
      //     questionHub.$emit('answer-added', answer)
      //   })
      //   connection.on('LiveChatMessageReceived', (username, text) => {
      //     questionHub.$emit('chat-message-received', { username, text })
      //   })

      // You need to call connection.start() to establish the connection but the client wont handle reconnecting for you!
      // Docs recommend listening onclose and handling it there.
      // This is the simplest of the strategies
      var to = null;
      function start() {
        startedPromise = connection.start().catch((e) => {
          if (e.message == "Unauthorized") {
            store.dispatch(LOGOUT);
            if (to) clearTimeout(to);
            return;
          }
          return new Promise((resolve, reject) => {
            to = setTimeout(() => {
              start()
                .then(resolve)
                .catch(reject);
            }, 5000);
          });
        });
        return startedPromise;
      }
      connection.onclose(() => {
        if (!manuallyClosed) start();
      });

      // Start everything
      manuallyClosed = false;
      start();
    };
    Vue.prototype.stopSignalR = () => {
      if (!startedPromise) return;

      manuallyClosed = true;
      return startedPromise
        .then(() => connection.stop())
        .then(() => {
          startedPromise = null;
        });
    };
  },
};
